import { getFutureMonth } from './date';
import cookie from 'js-cookie';
import { getHeapCookie } from './heap';
import { geoData } from './geo';
import { varsFromServer } from './client_side_injection_vars';
import { getUtmParamsFromCookie } from './utm';

export async function getDefaultLeadsFormData(leadSourceDetail) {
  const mixpanelId = window.mixpanel ? window.mixpanel.get_distinct_id() : '';
  const firstReferringDomain = cookie.get('we_referring_domain') || '';
  const googleAnalyticsId = cookie.get('_ga') || '';
  const { countryCode } = await geoData;

  // user's browser language setting
  // prefer navigator.languages (for Chrome). userLanguage is for IE11
  const navigatorLanguage =
    (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
  const locale = navigatorLanguage || varsFromServer.locale || 'en';

  return {
    lead_source_detail: leadSourceDetail,
    country_code: countryCode,
    locale,
    heap_should_track: true,
    heap_session_id: getHeapCookie().sessionId || '',
    lead_source: 'WeWork.com',
    sales_flow: 'wework',
    first_referring_domain: firstReferringDomain,
    mixpanel_id: mixpanelId,
    google_id: googleAnalyticsId,
    app_version: '7.0.0',
    ...getUtmParamsFromCookie()
  };
}

const monthIndexMap = {
  thisMonth: 0,
  nextMonth: 1,
  other: 2
};

export function getFormattedMoveInDate(moveInDateString) {
  const futureMonth = getFutureMonth(monthIndexMap[moveInDateString]);
  const currentMonthIndex = new Date().getMonth();
  const now = new Date();
  const year = futureMonth.index < currentMonthIndex ? now.getFullYear() + 1 : now.getFullYear();
  return `${year}-${futureMonth.formatted}-01`;
}

export function makeLeadServiceRequest(leadFormData, serviceParamsNotInForm, building, step) {
  const isTour = !!(leadFormData.tourDate && leadFormData.tourTimes);
  return {
    ...serviceParamsNotInForm,
    contact_name: leadFormData.fullName,
    email: leadFormData.email,
    phone: leadFormData.phone,
    notes: leadFormData.notes,
    move_in_date: getFormattedMoveInDate(leadFormData.moveInDate),
    company_size: leadFormData.desiredCapacity,
    marketing_consent: leadFormData.marketing_consent,
    ...(step === 1 && {
      desired_capacity: leadFormData.desiredCapacity,
      move_in_time_frame: leadFormData.moveInDate,
      submission_type: 'lead'
    }),
    interests: {
      building_ids: [building.id]
    },
    ...(leadFormData.companyName && {
      company_name: leadFormData.companyName
    }),
    ...(step === 2 && {
      submission_type: isTour ? 'tour' : 'lead',
      company_name: leadFormData.companyName,
      promo_code: leadFormData.promoCode,
      notes: leadFormData.notes,
      ...(isTour && {
        tour: {
          building_id: building.id,
          date: leadFormData.tourDate,
          time: leadFormData.tourTimes.replace(/\s/g, ''), // Remove space in "10:00 AM"
          notes: leadFormData.notes
        }
      })
    })
  };
}
